<template>
  <div>
    <div class="bg-green p-40 mb-40">
      <div class="subheading-3">Integrated with Shopify</div>
      <div class="b1">This account is synced with Shopify. Editing capabilities are limited.</div>
    </div>
  </div>
</template>

<script>

export default {
  name: "sub-order",
};
</script>
